import { useState } from "react";
import { toast } from "sonner";
import { Bookmark, BookmarkPlus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { SI, siErr, useSI } from "@/lib/sourcing";
import { EMPTY_F, activeCount } from "@/components/si/TalentFilters";

const URL_ = `${SI}/talent/saved-filters`;
const notLive = (e) => (e.response?.status === 404 ? "Saved filters aren't live on the backend yet (spec §75)." : siErr(e));

// §75 Personal saved filter combos: one tap to reopen.
export const SavedFilters = ({ q, f, onApply }) => {
  const r = useSI(URL_);
  const [naming, setNaming] = useState(false);
  const [name, setName] = useState("");
  const items = r.data?.items || [];
  const can = !!q.trim() || activeCount(f) > 0;
  const save = async () => {
    if (!name.trim()) return toast.error("Give this filter a name.");
    try { await api.post(URL_, { name: name.trim(), q: q.trim(), filters: f }); toast.success("Filter saved"); setNaming(false); setName(""); r.reload(); } catch (e) { toast.error(notLive(e)); }
  };
  const del = async (x) => { try { await api.delete(`${URL_}/${x.id}`); r.reload(); } catch (e) { toast.error(notLive(e)); } };
  if (r.missing && !can) return null;
  return (
    <div className="mb-2 flex flex-wrap items-center gap-1.5" data-testid="talent-saved">
      {items.map((x) => <span key={x.id} className="inline-flex items-center rounded-full border border-[#8224e3]/40 bg-[#8224e3]/10 text-[11px] text-[#d7b6ff]">
        <button onClick={() => onApply(x.q || "", { ...EMPTY_F, ...(x.filters || {}) })} className="inline-flex items-center gap-1 py-0.5 pl-2 pr-1 hover:text-white" data-testid={`talent-saved-${x.id}`}><Bookmark className="h-3 w-3" />{x.name}</button>
        <button onClick={() => del(x)} title="Delete saved filter" className="py-0.5 pl-0.5 pr-1.5 text-[#d7b6ff]/60 hover:text-red-300" data-testid={`talent-saved-${x.id}-del`}><X className="h-3 w-3" /></button></span>)}
      {naming ? <span className="flex items-center gap-1">
        <Input autoFocus value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && save()} placeholder='e.g. "Denver golang, last 30 days"' className="h-7 w-56 text-xs" data-testid="talent-saved-name" />
        <Button size="sm" onClick={save} className="h-7 bg-[#D4AF37] px-2 text-xs text-black hover:bg-[#F3C649]" data-testid="talent-saved-save">Save</Button>
        <Button size="sm" variant="ghost" onClick={() => setNaming(false)} className="h-7 px-2 text-xs text-zinc-400" data-testid="talent-saved-cancel">Cancel</Button></span>
        : can && <button onClick={() => setNaming(true)} className="inline-flex items-center gap-1 text-[11px] text-zinc-400 hover:text-[#F3C649]" data-testid="talent-saved-open"><BookmarkPlus className="h-3.5 w-3.5" />Save these filters</button>}
    </div>
  );
};
